import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { labels, data, backgroundColor, borderColor } from "../../utils/const";

const OrdersChart = () => {
  const [chartData, setChartData] = useState({});

  const Chart = () => {
    //let orderData = [];

    setChartData({
      labels,
      datasets: [
        {
          label: ["Users"],
          data,
          backgroundColor,
          borderColor,
          borderWidth: 1,
          borderCapStyle: "butt",
          borderRadius: 6,
          fill: true,
        },
      ],
    });
  };

  useEffect(() => {
    Chart();
  }, []);

  return (
    <React.Fragment>
      <h3>
        <u>Orders evolution chart</u>
      </h3>
      <div>
        <Doughnut
          data={chartData}
          options={{
            responsive: true,
            title: { text: "Orders", display: true },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default OrdersChart;
